import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFamilyMembers = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:currentColor;}.a,.c{stroke:currentColor;stroke-width:1.5px;}.b{clip-path:url(#a);}.c,.d{fill:none;}.c{stroke-linecap:round;stroke-linejoin:round;}" }) }), /* @__PURE__ */ _jsx("g", {
		className: "b",
		transform: "translate(-14110 -251)",
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(14110 251)",
			children: [/* @__PURE__ */ _jsxs("g", {
				transform: "translate(2.88 5.76)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M11.775,14.9a1.082,1.082,0,1,0,1.53,0,1.082,1.082,0,0,0-1.53,0",
						transform: "translate(3.422 -9.638)"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M32.393,13.232a2.5,2.5,0,1,1-3.536,0,2.5,2.5,0,0,1,3.536,0",
						transform: "translate(-21.485 -12.5)"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M32.958,33.167v-1a3,3,0,0,0-3-3h-3a3,3,0,0,0-3,3v1",
						transform: "translate(-19.318 -21.167)"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M7.292,30.574H8.821c1.267,0,1.748.51,1.748,1.777v.765",
						transform: "translate(7.717 -21.676)"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M13.3,14.9a1.082,1.082,0,1,1-1.53,0,1.082,1.082,0,0,1,1.53,0",
						transform: "translate(-10.216 -9.638)"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M10.568,30.574H9.039c-1.267,0-1.748.51-1.748,1.777v.765",
						transform: "translate(-7.292 -21.676)"
					})
				]
			}), /* @__PURE__ */ _jsx("path", {
				className: "d",
				d: "M0,0H24V24H0Z"
			})]
		})
	})]
});
export default SvgFamilyMembers;
